import axios from "../api";
export const getActiveSquad = async () => {
    const res = await axios.get("/user-squads/active");
    return res.data;
};
//# sourceMappingURL=getActiveSquad.js.map